<form [formGroup]="formGroup">
  <div class="d-flex flex-column">
    <div class="field-container">
      <h3> {{'createProposal.individualClausesConditionsQuestion'|translate}}</h3>
    </div>

    <app-input-field [control]="formGroup.controls.individualConditionsFreeText" class="field-container"
                     [label]="'createProposal.individualConditionsPlaceholder'|translate">
      <textarea formControlName="individualConditionsFreeText"
                class="input input-text-area" cdkTextareaAutosize
                [cdkAutosizeMinRows]="3"> </textarea>
    </app-input-field>

    <app-input-field [control]="formGroup.controls.individualClausesFreeText" class="field-container"
                     [label]="'createProposal.individualClausesPlaceholder'|translate">
      <textarea formControlName="individualClausesFreeText"
                class="input input-text-area" cdkTextareaAutosize
                [cdkAutosizeMinRows]="3"> </textarea>
    </app-input-field>
  </div>

  <div class="d-flex flex-column">
    <span
      class="small-title"> {{'proposalDetails.createOfferTab.fileUploadSection.title'|translate}}</span>
    <div class="d-flex field-container">
      <app-upload
      [uploadLocation]="UploadLocation.INDIVIDUALCLAUSESCONDITIONS"
      (updateAttachedFilesInParent)="attachFiles($event)"
      class="w-100"
      ></app-upload>
    </div>
  </div>
</form>
